import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { questions } from '../data/questions';
import { calculateResults } from '../utils/scoring';
import { QuestionCard } from '../components/QuestionCard';
import { ProgressBar } from '../components/ProgressBar';
import { Button } from '../components/ui/Button';
import { ChevronRightIcon, ChevronLeftIcon } from 'lucide-react';
export function AssessmentPage() {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(0);
  const [answers, setAnswers] = useState<Record<string, number>>({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const currentQuestion = questions[currentStep];
  const totalQuestions = questions.length;
  const isLastQuestion = currentStep === totalQuestions - 1;
  const hasAnsweredCurrent = answers[currentQuestion.id] !== undefined;
  const handleSelect = (value: number) => {
    setAnswers(prev => ({
      ...prev,
      [currentQuestion.id]: value
    }));
    // Optional: Auto-advance after selection with a small delay for better UX
    // setTimeout(() => {
    //   if (!isLastQuestion) handleNext();
    // }, 400);
  };
  const handleNext = () => {
    if (currentStep < totalQuestions - 1) {
      setCurrentStep(prev => prev + 1);
      window.scrollTo(0, 0);
    }
  };
  const handlePrevious = () => {
    if (currentStep > 0) {
      setCurrentStep(prev => prev - 1);
    }
  };
  const handleSubmit = () => {
    setIsSubmitting(true);
    // Simulate processing delay for "calculating" feel
    setTimeout(() => {
      const results = calculateResults(answers);
      navigate('/relatorio', {
        state: {
          results
        }
      });
    }, 1500);
  };
  return <div className="min-h-screen bg-slate-50 flex flex-col items-center py-12 px-4 sm:px-6" data-id="element-33">
      <div className="w-full max-w-2xl" data-id="element-34">
        {/* Header / Progress */}
        <div className="mb-8" data-id="element-35">
          <div className="flex justify-between items-center mb-6" data-id="element-36">
            <h1 className="text-2xl font-bold text-slate-900" data-id="element-37">
              Avaliação de Maturidade
            </h1>
            <span className="text-sm font-medium text-slate-500" data-id="element-38">
              Questão {currentStep + 1} de {totalQuestions}
            </span>
          </div>
          <ProgressBar current={currentStep + 1} total={totalQuestions} data-id="element-39" />
        </div>

        {/* Question Card */}
        <div className="bg-white rounded-2xl shadow-xl border border-slate-200 p-6 md:p-10 mb-8 min-h-[400px] flex flex-col justify-center" data-id="element-40">
          <QuestionCard question={currentQuestion} selectedValue={answers[currentQuestion.id]} onSelect={handleSelect} data-id="element-41" />
        </div>

        {/* Navigation Actions */}
        <div className="flex justify-between items-center" data-id="element-42">
          <Button variant="ghost" onClick={handlePrevious} disabled={currentStep === 0} className={currentStep === 0 ? 'invisible' : ''} data-id="element-43">
            <ChevronLeftIcon className="w-4 h-4 mr-2" data-id="element-44" />
            Anterior
          </Button>

          {isLastQuestion ? <Button onClick={handleSubmit} disabled={!hasAnsweredCurrent || isSubmitting} size="lg" className="min-w-[140px]" data-id="element-45">
              {isSubmitting ? 'Gerando Relatório...' : 'Finalizar Avaliação'}
            </Button> : <Button onClick={handleNext} disabled={!hasAnsweredCurrent} className="group" data-id="element-46">
              Próxima
              <ChevronRightIcon className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-47" />
            </Button>}
        </div>
      </div>
    </div>;
}